(function(window) {
  'use strict';

  function extend() {
    for (var i = 1; i < arguments.length; i++) {
      for (var key in arguments[i]) {
        if (arguments[i].hasOwnProperty(key)) {
          arguments[0][key] = arguments[i][key];
        }
      }
    }
    return arguments[0];
  }

  function directStrategy() {
    var opt = extend({}, defaultOptions);

    // won't overwrite belboon, zanox, google or other direct cookies
    if (docCookies.hasItem(opt.name)) return;

    docCookies.setItem(
        opt.name,
        opt.value,
        opt.end,
        opt.path,
        opt.domain,
        opt.secure
    );
  }

  function belboonStrategy() {
    var opt = extend({}, defaultOptions);
    var cookie;

    // won't overwrite other belboon cookies
    if (docCookies.hasItem(opt.name)) {
      cookie = JSON.parse(docCookies.getItem(opt.name));
      if (cookie.params.utm_source == 'belboon') return;
    }

    docCookies.setItem(
        opt.name,
        opt.value,
        opt.end,
        opt.path,
        opt.domain,
        opt.secure
    );
  }

  function zanoxStrategy() {
    var opt = extend({}, defaultOptions);
    var cookie;

    // won't overwrite other zanox cookies
    if (docCookies.hasItem(opt.name)) {
      cookie = JSON.parse(docCookies.getItem(opt.name));
      if (cookie.params.utm_source == 'zanox') return;
    }

    docCookies.setItem(
        opt.name,
        opt.value,
        opt.end,
        opt.path,
        opt.domain,
        opt.secure
    );
  }

  function googleStrategy() {
    var opt = extend({}, defaultOptions);
    var cookie;

    // won't overwrite belboon, zanox or other google cookies
    if (docCookies.hasItem(opt.name)) {
      cookie = JSON.parse(docCookies.getItem(opt.name));
      if (cookie.params.utm_source == 'google') return;
    }

    docCookies.setItem(
        opt.name,
        opt.value,
        opt.end,
        opt.path,
        opt.domain,
        opt.secure
    );
  }

  function runTracking() {
    if (tracking.params) {
      if (tracking.params.utm_source && strategyConfig.hasOwnProperty(tracking.params.utm_source)) {
        strategyConfig[tracking.params.utm_source].call(this);
      } else if (!tracking.params.utm_source) {
        strategyConfig['direct'].call(this);
      } else {
        strategyConfig['google'].call(this);
      }
    }
  }

  var docCookies = {
    //https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
    getItem: function (sKey) {
      if (!sKey) { return null; }
      return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
      var sExpires = "";
      if (vEnd) {
        switch (vEnd.constructor) {
          case Number:
            sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;
          case String:
            sExpires = "; expires=" + vEnd;
            break;
          case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
            break;
        }
      }
      document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
      return true;
    },
    removeItem: function (sKey, sPath, sDomain) {
      if (!this.hasItem(sKey)) { return false; }
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
      return true;
    },
    hasItem: function (sKey) {
      if (!sKey) { return false; }
      return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    },
    keys: function () {
      var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
      for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
      return aKeys;
    }
  };

  var tracking = {};
  tracking.referrer = document.referrer ? document.referrer : 'direct';
  tracking.created  = Math.floor(new Date().getTime() / 1000);
  tracking.landing = document.location.href;
  tracking.queryString = window.location.search ? window.location.search.substring(1) : window.location.hash.substring(1);
  tracking.params = tracking.queryString.split('&').reduce(function (previousValue, currentValue) {
    var splitValue = currentValue.split('=');
    previousValue[splitValue[0]] = splitValue[1];

    return previousValue;
  }, {});

  //End Date
  var date = new Date();

  // Add 30 days to cookie life time
  date.setTime(date.getTime() + 2592000000);

  var defaultOptions = {
    name: 'campanda_tracking',
    value: JSON.stringify(tracking),
    end: date.toGMTString(),
    path: '/',
    domain: null,
    secure: false
  };

  var strategyConfig = {
    // partner: strategy
    direct: directStrategy,
    belboon: belboonStrategy,
    zanox: zanoxStrategy,
    google: googleStrategy
  };

  runTracking();

}(window));
